<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      src="@/assets/edge-capacity.svg"
      alt="edge capacity logo"
    />
  </div>
  <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
  <layout>
    <div class="flex flex-col items-start">
      <div class="flex items-center">
        <img
          class="mr-3 h-5 w-5"
          src="@/assets/yellow-checkmark.svg"
          alt="yellow checkmark"
        />
        <h3 class="text-left text-3xl text-dark-blue">Success!</h3>
      </div>
      <p class="pt-6 text-left">
        Your account has been created! Highway has secured your identity as a
        carrier and you now have the ability to add more users.
      </p>
      <p class="pt-6 text-left">
        Continue to build your Company's Highway Profile.
      </p>
      <button-main
        class="mt-6"
        type="button"
        @click="handleClick"
      >
        Continue
      </button-main>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'AccountSuccess',
  components: {
    Layout,
    ButtonMain,
  },
  data() {
    return {
      packet_id: '',
    };
  },
  mounted() {
    this.findUser();
  },
  methods: {
    async findUser() {
      await this.$store.dispatch('users/identifyUser');
      const onboardingPacket = await this.$store.dispatch(
        'onboardingPacket/getOnboardingPacket'
      );
      this.packet_id = onboardingPacket.data[0]?.id;
      await this.$store.dispatch('onboardingPacket/getOnboardingPacketById', {
        id: onboardingPacket.data[0]?.id,
      });
    },
    handleClick() {
      // this.$store.commit("carriers/setCarrierData", this.data);

      this.$router.push({
        name: 'Carrier Onboarding Packet',
        params: { id: this.packet_id },
      });
    },
  },
};
</script>
